import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { LanguageService } from "../core/services/language.service";
import { APP_NAME } from "../core/constants/app.constants";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./app-footer.component.html",
  styleUrl: "./app-footer.component.scss",
})
export class AppFooterComponent {
  readonly appName = APP_NAME;
  readonly copy = inject(LanguageService).copy;
}
